"use strict";

/*eslint-disable*/module.exports = {
  messages: {
    "Do you have additional feedback about this information?": "Do you have additional feedback about this information?",
    "It didn't address my needs": "It didn't address my needs",
    "It wasn't what I was looking for": "It wasn't what I was looking for",
    "NOTE: Your comments here can only be seen by our editor": "NOTE: Your comments here can only be seen by our editor",
    "No": "No",
    "Please tell us why": "Please tell us why",
    "Something else": "Something else",
    "Submit feedback": "Submit feedback",
    "Thank you. We've recorded your feedback.": "Thank you. We've recorded your feedback.",
    "The information was difficult to understand": "The information was difficult to understand",
    "Was this information helpful?": "Was this information helpful?",
    "Why wasn't this information helpful?": "Why wasn't this information helpful?",
    "Yes": "Yes"
  }
};